import { render } from "./MobileDetail.vue?vue&type=template&id=3383e79f&scoped=true&ts=true"
import script from "./MobileDetail.vue?vue&type=script&lang=ts"
export * from "./MobileDetail.vue?vue&type=script&lang=ts"

import "./MobileDetail.vue?vue&type=style&index=0&id=3383e79f&lang=less&scoped=true"

import exportComponent from "/Users/jingshushu/homework/movie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3383e79f"]])

export default __exports__